// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"2a63668c","773":"1258d423","926":"0b3531fb"}[chunkId] + ".chunk.js";
};